import _ from 'lodash';
import * as types from '@/store/types';

const screenSizeModule = {
    state: {
        xs: false,
        sm: false,
        md: false,
        lg: false,
        xlg: false,
    },
    mutations: {
        [types.SCREEN_SIZE__MUTATE_SCREEN](state, screenSizeType) {
            const sizes = ['xs', 'sm', 'md', 'lg', 'xlg'];

            _.forEach(sizes, (value) => {
                state[value] = value === screenSizeType;
            });
        },
    },
    actions: {
        [types.SCREEN_SIZE__UPDATE_SCREEN]({ commit }, payload) {
            commit(types.SCREEN_SIZE__MUTATE_SCREEN, payload);
        },
    },
    getters: {
        [types.SCREEN_SIZE__GET_DESKTOP_SCREEN](state) {
            return state.md || state.lg || state.xlg;
        },
        [types.SCREEN_SIZE__GET_TABLET_SCREEN](state) {
            return state.sm;
        },
        [types.SCREEN_SIZE__GET_MOBILE_SCREEN](state) {
            return state.xs;
        },
    },
};

export default screenSizeModule;
